export default {
	currentUserFullName(state) {
		return `${state.currentUser.given_name} ${state.currentUser.family_name}`;
	},
};
